import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=3800c61a&scoped=true"
import script from "./BaseError.vue?vue&type=script&lang=js"
export * from "./BaseError.vue?vue&type=script&lang=js"
import style0 from "./BaseError.vue?vue&type=style&index=0&id=3800c61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800c61a",
  null
  
)

export default component.exports